import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDeleteDraftAuftragMutation, useGetDraftListMutation } from "../../../api/AuftragAPI";
import { IAuftrag } from "../../../types/Types";
import { useNavigate } from "react-router-dom";

interface ThisProps {
}

/**
 * @author noone
 */
const ListDraftAuftraege: React.FC<ThisProps> = (props) => {

  const { t } = useTranslation();
  const navigate = useNavigate();

  const [getListeAPI] = useGetDraftListMutation();
  const [deleteDraftAPI] = useDeleteDraftAuftragMutation();

  const [liste, setListe] = useState<IAuftrag[]>([]);

  function getListe() {
    getListeAPI().unwrap()
      .then(setListe)
      .catch((e) => console.log(e))
      ;
  }

  function deleteDraw(uid: string) {
    deleteDraftAPI(uid).unwrap()
      .then(() => {
        getListe();
      })
      .catch((error) => console.log(error))
      ;
  }

  useEffect(() => {
    getListe();
  }, [props]);

  return (
    <>
      {liste &&
        <>
          <div className="rounded" style={{ margin: "30px 20px", padding: "20px", backgroundColor: "#eccd93" }}>
            <h4>Entwürfe</h4>
            {liste.map((e, index) =>
              <>
                <div className="card" key={"draftlist_" + index}>
                  <div className="card-body">{e.vorname_endkunde} {e.name_endkunde} {e.auftragsnr_ag}</div>
                  <div className="card-footer">
                    <button title="" className="btn btn-outline-secondary" style={{marginRight:"20px"}} onClick={() => navigate("neuerauftrag", { state: { action: 'draft', uid: e.uid } })}><i translate="no" title={t('deTranslation.eigeneAuftraege.edit')} style={{ cursor: "pointer", fontSize: "18pt" }} className="bi bi-pencil"></i></button>
                    <button title="" className="btn btn-danger" onClick={() => {if (window.confirm('Entwurf wirklich löschen?')) deleteDraw(e.uid)}}><i translate="no" title={t('deTranslation.eigeneAuftraege.delete')} style={{ cursor: "pointer", fontSize: "18pt" }} className="bi bi-trash"></i></button>
                  </div>
                </div>
              </>
            )}
          </div>
        </>}
    </>
  );

}

export default ListDraftAuftraege;